export function fmtClient(clientAccountId,userContext) {
  if(userContext) {
    if(userContext.clients && clientAccountId in userContext.clients) {
      if(userContext.clients[clientAccountId].ClientAccountAlias) {
        return userContext.clients[clientAccountId].ClientAccountAlias;
      }
    }
  }
  return clientAccountId;
}
